export enum NotificationType {
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  FATAL = 'fatal',
}

export type BaseNotification = {
  id: string;
  title: string;
  description: string;
  read: boolean;
  type: NotificationType;
  timestamp: Date;
  severity: string;
  code?: string;
  readMoreUrl?: string;
  solution?: string;
  onClick?: () => void;
};

export enum SupportedLanguages {
  ENGLISH = 'en',
}
